module.exports = __webpack_public_path__ + "static/media/CTLA_4-356w.32369b29.webp";